import React from 'react';
import { Link } from 'react-router-dom';
import { DownloadIcon, MailIcon } from 'lucide-react';
const contactLinkClass = 'inline-flex items-center gap-1.5 whitespace-nowrap rounded text-muted underline-offset-4 transition-colors duration-150 hover:text-black hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link';
type SiteHeaderProps = {
  /** Render as the page header (default) or as the repeated site footer. */
  as?: 'header' | 'footer';
};
export function SiteHeader({
  as = 'header'
}: SiteHeaderProps) {
  const Tag = as;
  const isFooter = as === 'footer';
  return <Tag className={`flex flex-col gap-3 md:flex-row md:items-center md:justify-between ${isFooter ? 'border-t border-black/10 pt-8' : ''}`} data-id="element-113" data-mp="14ubzvggk2y86">
      <Link to="/" className="flex w-fit items-center gap-x-2 rounded text-[clamp(13px,4vw,16px)] leading-6 min-[700px]:gap-x-[14px] min-[700px]:text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link" data-id="element-114" data-mp="2gaaedzui6cgs">
        <span className="whitespace-nowrap font-bold" data-id="element-115" data-mp="2ei3s0xatdf4c">MICHAEL MEIKSON</span>
        <span className="whitespace-nowrap text-muted" data-id="element-116" data-mp="2ji9g63hvkjho">Principal Product Designer</span>
      </Link>
      <nav className="flex items-center gap-6 text-[clamp(13px,4vw,16px)] leading-6 min-[700px]:gap-8 min-[700px]:text-base" aria-label={isFooter ? 'Footer contact' : 'Contact'} data-id="element-117" data-mp="2ogt1q2sk3t9i">
        <a href="https://cdn.magicpatterns.com/uploads/pwegPEgunv1kfUYB7UCBEg/Michael_Meikson_Resume.pdf" download="Michael_Meikson_Resume.pdf" target="_blank" rel="noopener noreferrer" className={contactLinkClass} data-id="element-118" data-mp="1vrvwp1dcvsyp">
          <DownloadIcon aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={2} data-id="element-119" data-mp="25k1puefcggfh" />
          Download Resume
        </a>
        <a href="mailto:mike@meikson.com" className={contactLinkClass} data-id="element-120" data-mp="1d1e4qz0cl1ee">
          <MailIcon aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={2} data-id="element-121" data-mp="1czl1ltoy0zb5" />
          mike@meikson.com
        </a>
      </nav>
    </Tag>;
}